<template>
  <div>
    <h2 class="my-machine-custom-vehicle-data__title">
      {{ t('addedVehiclesTitle') }}
    </h2>
    <p class="my-machine-custom-vehicle-data__description">
      *{{ t('addedVehiclesDisclaimer') }}
    </p>

    <!-- TABLE -->
    <oie-base-table v-if="mq('medium')" class="my-machine-custom-vehicle-data">
      <template #head>
        <th>{{ t('vehicleTypeHeading') }}</th>
        <th>{{ t('vehicleBrandHeading') }}</th>
        <th>{{ t('vehicleModelHeading') }}</th>
      </template>
      <tr v-for="(item, index) in customVehiclesFlattened" :key="`custom-vechicle-row-${index}`" class="my-machine-custom-vehicle-data__body">
        <td>
          <oie-editable-content :display-value="displayValue(item, index, 'type')" @change="updateCustomMachine({id: item.type.id, name: $event})" @delete="handleDelete(item['type'].id, item['type'].name, deleteCustomMachine, t('typeWarningText'))"></oie-editable-content>
        </td>
        <td>
          <oie-editable-content :display-value="displayValue(item, index, 'brand')" @change="updateCustomMachine({id: item.brand.id, name: $event})" @delete="handleDelete(item['brand'].id, item['brand'].name, deleteCustomMachine, t('brandWarningText'))"></oie-editable-content>
        </td>
        <td>
          <oie-editable-content :display-value="displayValue(item, index, 'model')" @change="updateCustomMachine({id: item.model.id, name: $event})" @delete="handleDelete(item['model'].id, item['model'].name, deleteCustomMachine)"></oie-editable-content>
        </td>
      </tr>
    </oie-base-table>

    <!-- TREE -->
    <oie-vehicle-tree v-else></oie-vehicle-tree>

    <div class="my-machine-custom-vehicle-data__custom-fields">
      <div>
        <h2 class="my-machine-custom-vehicle-data__title">
          {{ t('addedFieldsTitle') }}
        </h2>
        <oie-hover-list>
          <li v-for="item in machineCustomFieldOptions" :key="item.id">
            <oie-editable-content :display-value="item.text" @change="updateCustomField({id: item.value, name: $event})" @delete="handleDelete(item.value, item.text, deleteCustomField)"></oie-editable-content>
          </li>
        </oie-hover-list>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

export default {
  computed: {
    ...mapGetters('myMachines', ['customVehicles', 'machineCustomFieldOptions']),
    customVehiclesFlattened() {
      const flattendData = []
      _.forEach(this.customVehicles, type => {
        if(type.brands.length > 0) {
          _.forEach(type.brands, brand => {
            if(brand.models.length > 0) {
              _.forEach(brand.models, model => {
                flattendData.push({ type, brand, model })
              })
            } else {
              flattendData.push({ type, brand, model: {} })
            }
          })
        } else {
          flattendData.push({ type, brand: {}, model: {} })
        }
      })
      return flattendData
    }
  },
  methods: {
    ...mapActions('myMachines', ['updateCustomMachine', 'updateCustomField', 'deleteCustomMachine', 'deleteCustomField']),
    displayValue(item, i, key) {
      if (i === 0) {
        if(item[key].name) {
          return !item[key].customModel ? `${item[key].name}*` : item[key].name
        } else {
          return '-'
        }
      } else {
        const prevItem = this.customVehiclesFlattened[i - 1]
        if(prevItem[key] === item[key]) {
          return ''
        } else {
          if(item[key].name) {
            return !item[key].customModel ? `${item[key].name}*` : item[key].name
          } else {
            return '-'
          }
        }
      }
    },
    handleDelete(id, name, deleteAction, warningText) {
      this.publish('modal.show.generic', {
        header: `${this.t('deleteModalHeading')}: ${name}?`,
        text: warningText || this.t('genericWarningText'),
        buttons: [ {
          text: this.tStatic('genericDelete'),
          usePrimaryButton: true,
          handler: async () => {
            await deleteAction({ id: id })
            this.publish('modal.hide.generic')
          }
        }]
      })
    }
  }

}
</script>

<style lang="scss">
.my-machine-custom-vehicle-data__title {
  @include h3-semi-bold;
  margin-bottom: measure(quarter);
}

.my-machine-custom-vehicle-data {
  margin-bottom: measure(full);
}

.my-machine-custom-vehicle-data .my-machine-custom-vehicle-data__body > td:has(.editable-content__display-value:empty) {
  border-top: none;
}

.my-machine-custom-vehicle-data__description {
  @include body;
  margin-bottom: measure(eighth);
}

.my-machine-custom-vehicle-data__custom-fields {
  display: grid;
  gap: measure(full);
  grid-template-columns: 1fr;

  @include media('medium') {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
